import React, { useEffect, useState } from 'react';
import api from '../../../api/axiosConfig';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import '../../../styles/dashboard.css';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { AuthContext } from '../../../context/AuthContext';
import { useContext } from 'react';

interface Lab {
  _id: string;
  user_name?: string;
  user_email?: string;
  user_phone?: string;
  city?: string;
  taluk?: string;
  district?: string;
  state?: string;
  country?: string;
  pin_code?: string;
  user_role?: string;
}

interface GetUsersResponse {
  message: string;
  users: Lab[];
}

const LabList: React.FC = () => {
  const [labs, setLabs] = useState<Lab[]>([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [toast, setToast] = useState<{ type: 'success' | 'error'; message: string } | null>(null);
  const [labToBook, setLabToBook] = useState<string | null>(null);
  const navigate = useNavigate();
  const location = useLocation();
  const context = useContext(AuthContext);

  useEffect(() => {
    const fetchLabs = async () => {
      try {
        const res = await api.auth_api.get<GetUsersResponse>('/auth/get-labs');
        setLabs(res.data.users);
      } catch (error) {
        console.error('Error fetching labs:', error);
      }
    };

    fetchLabs();
  }, []);

  const filteredLabs = labs.filter((lab) => {
    const term = searchTerm.toLowerCase();
    return (
      lab.user_name?.toLowerCase().includes(term) ||
      lab.user_email?.toLowerCase().includes(term) ||
      lab.city?.toLowerCase().includes(term) ||
      lab.district?.toLowerCase().includes(term) ||
      lab.state?.toLowerCase().includes(term)
    );
  });

  const animal = location.state?.animal;

  useEffect(() => {
  if (!animal) {
    setToast({ type: "error", message: "No animal selected for the blood typing request" });
    navigate('/farmer'); // or wherever fallback should go
  }
}, []);

  const handleBookTest = async (labId: string) => {
  if (!animal) {
    setToast({ type: "error", message: "Animal Info not available" });
    return;
  }

  const locationString = `${animal.city}, ${animal.taluk}, ${animal.district}, ${animal.state}, ${animal.country} - ${animal.pin_code}`;

  try {
    await api.farmer_api.post('/bloodtyping/request', {
      labId,
      species: animal.species,
      breed: animal.breed,
      age: animal.age,
      location: locationString,
      owner_phone: context?.user?.owner_phone || context?.user?.user_phone || animal.user_phone || animal.owner_phone || '',
    });

    setToast({ type: 'success', message: 'Test Request sent successfully!' });
  } catch (err) {
    console.error('Error booking test:', err);
    setToast({ type: "error", message: "Failed to Book Test" });
  }
};

  return (
    <div className="center-page">
      {toast && (
        <div className={`global-toast ${toast.type}`}>
          <span>{toast.message}</span>
          <button className="toast-close" onClick={() => setToast(null)}>×</button>
        </div>
      )}
      
      <div className="dashboard-container">
        <div className="dashboard-header"> 
          <Link className="back-button" to="/farmer"><ArrowBackIcon/></Link> 
          <h2>Available Labs</h2>  
        </div>

        <div className="dashboard-content">
          <input
            type="text"
            placeholder="Search labs..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-box"
          />
          <div className="table-container">
            <table className="data-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Location</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {filteredLabs.map((lab) => (
                  <tr key={lab._id}>
                    <td>{lab.user_name}</td>
                    <td>{lab.user_email}</td>
                    <td>{lab.user_phone}</td>
                    <td>
                      {lab.city}
                    </td>
                    <td>
                      <button
                        className="form-button"
                        onClick={() => setLabToBook(lab._id)}
                      >
                        Book Test
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {filteredLabs.length === 0 && <p>No labs found.</p>}
          </div>
        </div>
      </div>

      {labToBook && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Confirm Booking</h3>
            <p>Are you sure you want to book a blood typing test with this lab?</p>
            <div className="form-buttons" style={{ display: 'flex', gap: '15px', marginTop: '20px' }}>
              <button
                className="form-button"
                onClick={() => {
                  handleBookTest(labToBook);
                  setLabToBook(null);
                }}
              >
                Yes, Book
              </button>
              <button
                className="form-button cancel-button"
                onClick={() => setLabToBook(null)}
                style={{ background: '#f5f5f5', color: '#333' }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default LabList;

